import {
  KnownProjectTeamMemberDtoAssociatedBrand,
  KnownProjectTeamMemberDtoStatus,
  KnownProjectTeamMembershipDtoAccessLevel,
  KnownProjectTeamMembershipDtoStatus,
  ProjectTeamMemberDto,
  ProjectTeamMembershipDto
} from '@groundfloor-platform/mgmt-service-g-sdk';
import { createPath, Paths } from '../../../../app/router/app.router';
import { TeamMemberDetailsPageHeaderProps } from '../../../../ui/components/pure/page-headers/details/team-member/team-member-details-page-header.component';
import { makeDefineTeamMemberDetailsActions, TeamMemberDetailsActions } from '../actions/team-member-details.actions';
import { teamMembershipAccessLevelStrings, teamMemberStatusStrings } from './team-member-details.constants';

export function makeTeamMemberDetailsHeaderProps(
  projectID: string,
  user: ProjectTeamMemberDto,
  setAction: (action: TeamMemberDetailsActions) => void,
  /** Worded for this project — see `useAccessLevelDescriptions`. */
  accessLevelDescriptions: Record<string, string>,
  memberships?: ProjectTeamMembershipDto[]
): TeamMemberDetailsPageHeaderProps {
  return {
    name: user.displayName,
    accessLevel: teamMembershipAccessLevelStrings[user.accessLevel as KnownProjectTeamMembershipDtoAccessLevel],
    accessLevelDescription: accessLevelDescriptions[user.accessLevel],
    role: user.role,
    status: teamMemberStatusStrings[user.status as KnownProjectTeamMemberDtoStatus],
    email: user.email,
    mobile: user.mobile,
    externalID: user.externalID,
    actions: makeDefineTeamMemberDetailsActions({ projectID, teamMember: user })(setAction),
    associatedBrand: user.associatedBrand as KnownProjectTeamMemberDtoAssociatedBrand,
    userDirectoryId: makeUserDirectoryIdContent(user),
    projectMemberships: makeProjectMemberships(projectID, memberships)
  };
}

function makeProjectMemberships(projectID: string, memberships?: ProjectTeamMembershipDto[]) {
  return memberships
    ?.filter((m) => m.projectID !== projectID)
    .map((m) => ({
      projectName: m.projectName,
      status: teamMemberStatusStrings[m.status as KnownProjectTeamMembershipDtoStatus] ?? m.status,
      link: createPath(Paths.teamMember, { projectID: m.projectID, teamMemberID: m.accountID })
    }));
}

function makeUserDirectoryIdContent(user: ProjectTeamMemberDto): string | undefined {
  if (user.status !== KnownProjectTeamMemberDtoStatus.Invited) {
    return user.userDirectoryId;
  }

  // If the Team Member status is "invited" but they have no user directory ID, it means the user will have
  // a user directory ID once they accept the invitation.
  // In this case, we return a message indicating that the invitation has not been accepted yet.
  if (!user.userDirectoryId) {
    return 'Invitation not accepted yet';
  }
  return user.userDirectoryId;
}
